import { useRecoilValue } from 'recoil';
import { favoritedProductsList } from '../state';

const useProductIsFavorited = (
  id: string,
  defaultValue?: boolean | null,
): boolean => {
  const favoritedList = useRecoilValue(favoritedProductsList);

  return favoritedList?.[id] ?? defaultValue;
};

export default useProductIsFavorited;
